import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me')
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (payload) => {
    const res = await api.post('/auth/login', payload);
    localStorage.setItem('token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const can = (...roles) => user && roles.includes(user.role);
  // Una clave que el servidor no manda es un backend mas viejo que este
  // frontend: se da por incluida, igual que antes de existir ese permiso. Un
  // modulo apagado de verdad llega como 0, nunca ausente, asi que esto no
  // abre nada que el servidor haya cerrado.
  const hasPlan = (feature) => !!user && (user[feature] === undefined || !!user[feature]);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can, hasPlan }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
